import React from 'react';
import { CodeBlock } from '../CodeBlock';
export const SmartValidation = () => {
    return (React.createElement("div", { className: "space-y-5" },
        React.createElement("header", null,
            React.createElement("h1", { className: "text-xl font-semibold text-gray-900" }, "Smart Validation"),
            React.createElement("p", { className: "text-gray-600 text-sm mt-1" }, "Use built-in validation flows to confirm, correct, or retry user inputs. Display compact validation actions below fields.")),
        React.createElement("section", { className: "space-y-3" },
            React.createElement("h2", { className: "text-sm font-semibold text-gray-800" }, "Enable Validation Actions"),
            React.createElement(CodeBlock, { language: "tsx", code: `// Enable field validation UI by passing options to FluidFormFields
<FluidFormFields field={fieldRenderView} options={{ useFieldValidation: true }} />` })),
        React.createElement("section", { className: "space-y-3" },
            React.createElement("h2", { className: "text-sm font-semibold text-gray-800" }, "Unified Form Validation"),
            React.createElement(CodeBlock, { language: "tsx", code: `<SimpleFormProvider
  render={(formProps, onSubmit, validationResults) => (
    <UnifiedFluidForm
      {...formProps}
      onSubmit={onSubmit}
      validationResults={validationResults}
    />
  )}
  form={form}
  submissionId="smart-validation"
/>` }))));
};
export default SmartValidation;
